/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Schnelle Wege`
};

const en_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Fast lanes`
};

const es_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Vías rápidas`
};

const fr_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Voies rapides`
};

const it_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Corsie preferenziali`
};

const nl_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Snelle rijstroken`
};

const pt_route_spec_card__roadsheet__highway = /** @type {(inputs: {}) => string} */ () => {
	return `Pistas rápidas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_spec_card__roadsheet__highway(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_spec_card__roadsheet__highway", locale)
	if (locale === "de") return de_route_spec_card__roadsheet__highway(inputs)
	if (locale === "en") return en_route_spec_card__roadsheet__highway(inputs)
	if (locale === "es") return es_route_spec_card__roadsheet__highway(inputs)
	if (locale === "fr") return fr_route_spec_card__roadsheet__highway(inputs)
	if (locale === "it") return it_route_spec_card__roadsheet__highway(inputs)
	if (locale === "nl") return nl_route_spec_card__roadsheet__highway(inputs)
	return pt_route_spec_card__roadsheet__highway(inputs)
};